module.exports = __webpack_public_path__ + "static/media/decumbens-basilisk.72cd65b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/decumbens-basilisk.jpg
// module id = 91
// module chunks = 0